<template>

  <header class="ni-header">

    <div class="ni-header__inner">

      <!-- Desktop -->

      <div class="ni-header__desktop">

        <a href="#home" class="ni-header__logo-link" @click="handleNavClick('#home', $event)">

          <div class="ni-header__logo">

            <img

              class="ni-header__logo-img"

              src="https://www.qdpic.cn/obs/images/195e37770fe5a66e8c08e916b144cce8.png"

              alt="HI QINGDAO"

            />

          </div>

        </a>



        <div class="ni-header__right">

          <div class="ni-header__top-row">

            <div class="ni-header__search-wrap">

              <form class="ni-header__search" @submit.prevent="handleSearchSubmit">

                <button

                  type="button"

                  class="ni-header__search-cat"

                  @click="showCategoryDropdown = !showCategoryDropdown"

                >

                  <img
                    class="ni-header__search-cat-arrow"
                    :src="newIndexSearchDropdownIcon"
                    alt=""
                    aria-hidden="true"
                  />

                  <span>{{ selectedCategory }}</span>

                </button>



                <div v-if="showCategoryDropdown" class="ni-header__dropdown-backdrop" @click="showCategoryDropdown = false"></div>

                <div v-if="showCategoryDropdown" class="ni-header__dropdown ni-animate-fade-in">

                  <button

                    v-for="cat in categoryOptions"

                    :key="cat.value"

                    type="button"

                    class="ni-header__dropdown-item"

                    @click="selectCategory(cat)"

                  >

                    {{ cat.label }}

                  </button>

                </div>



                <input

                  id="header-search-input"

                  v-model="searchQuery"

                  type="text"

                  class="ni-header__search-input"

                  :placeholder="t('newIndex.header.searchPlaceholder')"

                  @focus="preservePageScroll"

                  @input="preservePageScroll"

                />

                <button id="search-submit" type="submit" class="ni-header__search-btn" aria-label="Search">

                  <svg class="ni-icon ni-icon--search" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">

                    <circle cx="11" cy="11" r="8" />

                    <path d="m21 21-4.35-4.35" />

                  </svg>

                </button>

              </form>

            </div>



            <div id="lang-toggle-btn" class="ni-header__lang" title="Switch Language">

              <NewIndexChangeLang />

            </div>

          </div>



          <div class="ni-header__nav-row">

            <nav class="ni-header__nav">

              <a

                v-for="item in navItems"

                :key="item.labelKey"

                :href="item.href"

                class="ni-header__nav-link"

                :class="{ 'ni-header__nav-link--active': activeNav === item.href }"

                @click="handleNavClick(item.href, $event)"

              >

                <span>{{ t(item.labelKey) }}</span>

              </a>

            </nav>



            <div v-if="!isLoggedIn" class="ni-header__login-wrap">

              <button

                id="login-link"

                type="button"

                class="ni-header__login"

                @click="handleLogin"

              >

                <span class="ni-header__login-icon">

                  <svg class="ni-icon ni-icon--user" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">

                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />

                    <circle cx="12" cy="7" r="4" />

                  </svg>

                </span>

                <span>{{ t('newIndex.header.signIn') }}</span>

              </button>

            </div>



            <div v-else class="ni-header__user-wrap">

              <div class="ni-header__user-popover">

                <span class="ni-header__user-trigger" role="button" tabindex="0" :title="username">

                  <i class="iconfont icon-icontouxiang login-iconstyle" aria-hidden="true"></i>

                  <span class="ni-header__user-name">{{ username }}</span>

                </span>

                <div class="ni-header__user-menu">

                  <button

                    v-for="item in userMenuItems"

                    :key="item.id"

                    type="button"

                    class="ni-header__user-menu-item"

                    @click.stop="handleUserMenu(item)"

                  >

                    {{ item.name }}

                  </button>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>



      <!-- Mobile -->

      <div class="ni-header__mobile-wrap">

        <div class="ni-header__mobile">

          <a href="#home" class="ni-header__logo-link" @click="handleNavClick('#home', $event)">

            <img

              class="ni-header__logo-img ni-header__logo-img--mobile"

              src="https://www.qdpic.cn/obs/images/195e37770fe5a66e8c08e916b144cce8.png"

              alt="HI QINGDAO"

            />

          </a>



          <div class="ni-header__mobile-actions">

            <button

              id="mobile-menu-toggle"

              type="button"

              class="ni-header__mobile-btn ni-header__mobile-btn--menu"

              :aria-label="mobileMenuOpen ? 'Close menu' : 'Open menu'"

              @click="mobileMenuOpen = !mobileMenuOpen"

            >

              <svg v-if="mobileMenuOpen" class="ni-icon ni-icon--close" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">

                <path d="M18 6 6 18" />

                <path d="m6 6 12 12" />

              </svg>

              <svg v-else class="ni-icon ni-icon--menu" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">

                <path d="M4 6h16" />

                <path d="M4 12h16" />

                <path d="M4 18h16" />

              </svg>

            </button>



            <div

              id="mobile-lang-toggle"

              class="ni-header__mobile-btn ni-header__mobile-btn--lang"

              aria-label="Switch language"

            >

              <NewIndexChangeLang compact :show-icon="true" />

            </div>



            <button

              v-if="!isLoggedIn"

              id="mobile-login-link"

              type="button"

              class="ni-header__mobile-login"

              @click="handleLogin"

            >

              <span class="ni-header__login-icon">

                <svg class="ni-icon ni-icon--user" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">

                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />

                  <circle cx="12" cy="7" r="4" />

                </svg>

              </span>

              <span class="ni-header__mobile-login-text">{{ t('newIndex.header.signIn') }}</span>

            </button>



            <button

              v-else

              id="mobile-user-link"

              type="button"

              class="ni-header__mobile-user"

              :title="username"

              @click="toUserHome"

            >

              <i class="iconfont icon-icontouxiang login-iconstyle" aria-hidden="true"></i>
              <!-- <span class="ni-header__mobile-user-name">{{ username }}</span> -->
            </button>

          </div>

        </div>



        <form class="ni-header__mobile-search" @submit.prevent="handleSearchSubmit">

          <div class="ni-header__mobile-search-inner">

            <button

              type="button"

              class="ni-header__search-cat"

              @click="showMobileCategoryDropdown = !showMobileCategoryDropdown"

            >

              <img
                class="ni-header__search-cat-arrow"
                :src="newIndexSearchDropdownIcon"
                alt=""
                aria-hidden="true"
              />

              <span class="ni-header__mobile-search-cat-label">{{ selectedCategory }}</span>

            </button>



            <div v-if="showMobileCategoryDropdown" class="ni-header__dropdown-backdrop" @click="showMobileCategoryDropdown = false"></div>

            <div v-if="showMobileCategoryDropdown" class="ni-header__dropdown ni-header__dropdown--mobile ni-animate-fade-in">

              <button

                v-for="cat in categoryOptions"

                :key="`mobile-${cat.value}`"

                type="button"

                class="ni-header__dropdown-item"

                @click="selectCategory(cat)"

              >

                {{ cat.label }}

              </button>

            </div>



            <input

              id="mobile-header-search-input"

              v-model="searchQuery"

              type="text"

              class="ni-header__search-input"

              :placeholder="t('newIndex.header.searchPlaceholderMobile')"

              @focus="preservePageScroll"

              @input="preservePageScroll"

            />

            <button id="mobile-header-search-submit" type="submit" class="ni-header__search-btn" aria-label="Search">

              <svg class="ni-icon ni-icon--search" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">

                <circle cx="11" cy="11" r="8" />

                <path d="m21 21-4.35-4.35" />

              </svg>

            </button>

          </div>

        </form>

      </div>

    </div>



    <!-- Mobile drawer -->

    <Transition name="ni-header-drawer">

      <div v-if="mobileMenuOpen" class="ni-header__drawer ni-header__drawer--open">

        <div class="ni-header__drawer-nav">

          <a

            v-for="item in navItems"

            :key="item.href + item.labelKey"

            :href="item.href"

            class="ni-header__drawer-link"

            @click="closeMobileMenu(item.href)"

          >

            <span>{{ t(item.labelKey) }}</span>

            <span class="ni-header__drawer-link-arrow">→</span>

          </a>

        </div>



        <div class="ni-header__drawer-footer">

          <p class="ni-header__drawer-copy">

            {{ t('newIndex.header.copyright') }}

          </p>

          <button

            v-if="!isLoggedIn"

            id="mobile-resident-login"

            type="button"

            class="ni-header__drawer-cta"

            @click="handleLogin"

          >

            {{ t('newIndex.header.signIn') }}

          </button>

          <a

            v-else

            id="mobile-resident-login"

            href="#qd-service"

            class="ni-header__drawer-cta"

            @click="closeMobileMenu('#qd-service')"

          >

            {{ t('newIndex.header.foreignResidentHub') }}

          </a>

        </div>

      </div>

    </Transition>

  </header>

</template>



<script setup>

import { computed, getCurrentInstance, onBeforeUnmount, onMounted, ref, watch } from 'vue';

import { useRouter } from 'vue-router';

import { useI18n } from 'vue-i18n';

import NewIndexChangeLang from './NewIndexChangeLang.vue';
import { newIndexSearchDropdownIcon } from '@/data/newIndexAssets.js';



defineProps({

  isLoggedIn: {

    type: Boolean,

    default: false,

  },

  username: {

    type: String,

    default: '',

  },

});



const emit = defineEmits(['search', 'login']);



const router = useRouter();

const { proxy } = getCurrentInstance();

const { t, locale } = useI18n();



const userMenuItems = computed(() => [

  { id: 1, name: t('personCenter'), type: 'user' },

  { id: 2, name: t('logout'), type: 'exit' },

]);



const searchQuery = ref('');

const showCategoryDropdown = ref(false);
const showMobileCategoryDropdown = ref(false);

const selectedCategoryValue = ref('news');

const selectedCategory = ref('');

const mobileMenuOpen = ref(false);

const activeNav = ref('#home');



const navItems = [

  { labelKey: 'newIndex.nav.home', href: '#home' },

  { labelKey: 'newIndex.nav.trendingNews', href: '#latest-news' },

  { labelKey: 'newIndex.nav.vibrantCity', href: '#qingdao-world' },

  { labelKey: 'newIndex.nav.globalOutreach', href: '#int-communication' },

  { labelKey: 'newIndex.nav.photoGallery', href: '#photo-depot' },

  { labelKey: 'newIndex.nav.visualQingdao', href: '#visual-qingdao' },

  { labelKey: 'newIndex.nav.qdRelease', href: '#qd-release' },

  { labelKey: 'newIndex.nav.servicesHub', href: '#qd-service' },

];



const sectionIds = ['#home', '#latest-news', '#qingdao-world', '#int-communication', '#photo-depot', '#visual-qingdao', '#qd-release', '#vr-hall', '#qd-service'];

const navHrefs = navItems.map((item) => item.href);

let scrollContainer = null;
let scrollRaf = null;
let contentObserver = null;



const categoryOptions = computed(() => [

  { value: 'news', label: t('newIndex.categories.news') },

  { value: 'photos', label: t('newIndex.categories.photos') },

  { value: 'videos', label: t('newIndex.categories.videos') },

  { value: 'vr', label: t('newIndex.categories.vr') },

]);



function syncCategoryLabel() {

  const cat = categoryOptions.value.find((c) => c.value === selectedCategoryValue.value);

  selectedCategory.value = cat ? cat.label : t('newIndex.categories.news');

}



watch(locale, syncCategoryLabel, { immediate: true });

watch(mobileMenuOpen, (open) => {

  if (!open) showCategoryDropdown.value = false;

});

watch(showMobileCategoryDropdown, (open) => {

  if (open) showCategoryDropdown.value = false;

});

watch(showCategoryDropdown, (open) => {

  if (open) showMobileCategoryDropdown.value = false;

});



function handleLogin() {

  mobileMenuOpen.value = false;

  emit('login');

}



function handleUserMenu(item) {

  if (item.type === 'exit') {

    proxy.$cookies.removeToken();

    proxy.$cookies.removeUsername();

    proxy.$cookies.removeMobile();

    proxy.$cookies.removeTokentype();

    proxy.$cookies.removeAuthKey();

    location.reload();

    return;

  }

  if (item.type === 'user') {

    router.push('/my/setting');

  }

}



function toUserHome() {

  router.push('/my/home');

}



function handleSearchSubmit() {

  mobileMenuOpen.value = false;

  emit('search', {

    query: searchQuery.value,

    category: selectedCategoryValue.value,

  });

}



function selectCategory(cat) {

  selectedCategoryValue.value = cat.value;

  selectedCategory.value = cat.label;

  showCategoryDropdown.value = false;

  showMobileCategoryDropdown.value = false;

}



function resolveNavHref(sectionHref) {
  if (navHrefs.includes(sectionHref)) return sectionHref;

  const idx = sectionIds.indexOf(sectionHref);
  for (let i = idx; i >= 0; i -= 1) {
    if (navHrefs.includes(sectionIds[i])) return sectionIds[i];
  }

  return '#home';
}

function getSectionTop(container, el) {
  const containerRect = container.getBoundingClientRect();
  return el.getBoundingClientRect().top - containerRect.top + container.scrollTop;
}

function updateActiveNavFromScroll() {
  if (!scrollContainer) return;

  const scrollTop = scrollContainer.scrollTop;
  const threshold = scrollTop + getHeaderOffset() + 48;

  if (scrollTop < 8) {
    activeNav.value = '#home';
    return;
  }

  let currentSection = '#home';

  sectionIds.forEach((href) => {
    const el = document.getElementById(href.replace('#', ''));
    if (!el) return;

    if (getSectionTop(scrollContainer, el) <= threshold) {
      currentSection = href;
    }
  });

  activeNav.value = resolveNavHref(currentSection);
}

function handleScroll() {
  if (scrollRaf) return;

  scrollRaf = requestAnimationFrame(() => {
    scrollRaf = null;
    updateActiveNavFromScroll();
  });
}

function setActiveNav(href) {
  activeNav.value = href;
}



function handleResize() {
  updateActiveNavFromScroll();
}

function getScrollContainer() {

  return document.querySelector('.ni-page') || document.scrollingElement || document.documentElement;

}



function preservePageScroll() {

  const container = getScrollContainer();

  const savedTop = container.scrollTop;

  const restore = () => {

    if (container.scrollTop !== savedTop) {

      container.scrollTop = savedTop;

    }

  };

  requestAnimationFrame(() => {

    restore();

    requestAnimationFrame(restore);

  });

}



function getHeaderOffset() {

  const header = document.querySelector('.ni-header');

  return header ? header.offsetHeight : 0;

}



function scrollToAnchor(href) {

  const container = getScrollContainer();



  if (href === '#home') {

    container.scrollTo({ top: 0, behavior: 'smooth' });

    return;

  }



  const id = href.replace('#', '');

  const el = document.getElementById(id);

  if (!el) return;



  const headerOffset = getHeaderOffset();

  const containerRect = container.getBoundingClientRect();

  const elTop = el.getBoundingClientRect().top - containerRect.top + container.scrollTop;



  container.scrollTo({

    top: Math.max(0, elTop - headerOffset),

    behavior: 'smooth',

  });

}



function handleNavClick(href, event) {

  event.preventDefault();

  setActiveNav(href);

  scrollToAnchor(href);

}



function closeMobileMenu(href) {

  mobileMenuOpen.value = false;

  handleNavClick(href, { preventDefault: () => {} });

}



onMounted(() => {
  scrollContainer = getScrollContainer();
  updateActiveNavFromScroll();
  scrollContainer?.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', handleResize, { passive: true });

  // 异步区块（如青岛发布）挂载后重新计算当前导航
  const main = document.querySelector('.ni-page__main');
  if (main && typeof MutationObserver !== 'undefined') {
    contentObserver = new MutationObserver(() => {
      updateActiveNavFromScroll();
    });
    contentObserver.observe(main, { childList: true, subtree: true });
  }
});

onBeforeUnmount(() => {
  scrollContainer?.removeEventListener('scroll', handleScroll);
  window.removeEventListener('resize', handleResize);

  if (contentObserver) {
    contentObserver.disconnect();
    contentObserver = null;
  }

  if (scrollRaf) {
    cancelAnimationFrame(scrollRaf);
    scrollRaf = null;
  }

  scrollContainer = null;
});

</script>


